import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Crown, Trophy } from "lucide-react";

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  const [rounds, setRounds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [a, b] = await Promise.all([
          api.get("/leaderboard"),
          api.get("/game/history?limit=30"),
        ]);
        setRows(a.data);
        setRounds(b.data);
      } catch (err) {
        console.warn("leaderboard load failed:", err?.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="max-w-6xl mx-auto p-4 sm:p-6 lg:p-10" data-testid="leaderboard-page">
      <div className="label-mono mb-3">// 05_leaderboard</div>
      <h1 className="font-display font-black text-3xl lg:text-5xl tracking-tighter mb-2">TOP OPERATORS.</h1>
      <p className="text-white/60 mb-8 font-body">Ranked by all-time winnings on the grid.</p>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 panel p-0 overflow-hidden">
          <table className="w-full" data-testid="leaderboard-table">
            <thead>
              <tr className="border-b border-neon-line">
                <th className="text-left p-4 label-mono">Rank</th>
                <th className="text-left p-4 label-mono">Operator</th>
                <th className="text-right p-4 label-mono">Wins</th>
                <th className="text-right p-4 label-mono">Total Won</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={4} className="p-6 text-center font-mono text-white/40">loading…</td></tr>
              )}
              {!loading && rows.length === 0 && (
                <tr><td colSpan={4} className="p-6 text-center font-mono text-white/40">no winners yet · be the first</td></tr>
              )}
              {rows.map((r, i) => (
                <tr key={r.user_id} className="border-b border-neon-line/40 hover:bg-neon-green/5 transition-colors" data-testid={`leaderboard-row-${i}`}>
                  <td className="p-4 font-mono font-bold">
                    {i === 0 ? <Crown className="w-5 h-5 text-neon-green inline" /> : `#${i + 1}`}
                  </td>
                  <td className="p-4 font-body font-semibold">{r.name}</td>
                  <td className="p-4 text-right font-mono text-white/70">{r.wins}</td>
                  <td className="p-4 text-right font-mono text-neon-green font-bold">{r.total_won.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="panel p-6">
          <div className="flex items-center gap-2 mb-4">
            <Trophy className="w-4 h-4 text-neon-green" />
            <div className="label-mono">Recent Rounds</div>
          </div>
          <div className="space-y-2 max-h-[500px] overflow-y-auto">
            {rounds.length === 0 && <div className="text-white/40 text-xs font-mono">no rounds yet</div>}
            {rounds.map((r) => (
              <div key={r.round_id} className="flex items-center justify-between py-2 border-b border-neon-line/50 last:border-0 font-mono text-xs">
                <span className="text-white/40">{r.round_id.slice(2, 8)}</span>
                <span className={r.crash_point >= 2 ? "text-neon-green" : "text-neon-red"}>{r.crash_point.toFixed(2)}×</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
